module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"SearchInput":{"ariaLabel":"Vyhledávání","button":"Vyhledat","placeholder":"Napište co hledáte..."}}}')
  delete Component.options._Ctor
}
